import { render, staticRenderFns } from "./EscopoItens.vue?vue&type=template&id=663c1e0b&scoped=true"
import script from "./EscopoItens.vue?vue&type=script&setup=true&lang=js"
export * from "./EscopoItens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EscopoItens.vue?vue&type=style&index=0&id=663c1e0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c1e0b",
  null
  
)

export default component.exports